import { Link } from "react-router-dom";
import { games } from "../data/gamesData";
import BustHero from "../components/BustHero";

function Games() {
  return (
    <div className="max-w-6xl mx-auto py-10 px-4 md:px-8">
      <BustHero title="Game Marketplace" titleClassName="h2 mb-2">
        <p className="text-gray-400 max-w-2xl">
          Classic DOS shareware, playable right in your browser. Every game is free to play, and nothing
          downloads until you press Play.
        </p>
      </BustHero>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {games.map((game) => (
          <Link
            key={game.slug}
            to={`/games/${game.slug}`}
            className="group flex flex-col overflow-hidden rounded-xl border border-white/10 bg-gray-900/60 transition-all duration-300 hover:scale-[1.015] hover:border-white/25"
          >
            <div className="relative flex aspect-[16/9] items-end overflow-hidden p-5">
              <img
                src={game.cover}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                style={{ imageRendering: "pixelated" }}
              />
              <div
                aria-hidden="true"
                className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"
              />
              <h2 className="relative text-2xl font-black uppercase tracking-wide drop-shadow-[0_2px_0_rgba(0,0,0,.6)]">
                {game.title}
              </h2>
              <span className="absolute right-4 top-4 rounded-full bg-black/55 px-2.5 py-1 text-xs font-medium text-white/90 backdrop-blur-sm">
                {game.genre}
              </span>
            </div>

            <div className="flex flex-1 flex-col p-5">
              <p className="text-xs uppercase tracking-wider text-gray-500">
                {game.publisher} · {game.year}
              </p>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-gray-300">{game.blurb}</p>
              <div className="mt-4 flex items-center justify-between text-sm">
                <span className="text-gray-500">{game.sizeMb.toFixed(1)} MB</span>
                <span className="font-semibold text-emerald-300 transition-colors group-hover:text-emerald-200">
                  Play free →
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Games;
